import { theme as ChakraTheme, extendTheme } from '@chakra-ui/react';
import {
  ButtonTheme,
  CheckboxTheme,
  HeadingTheme,
  StatusCardTheme,
  SwitchTheme,
  radioTheme,
  tooltipTheme
} from '../components';
import { acertaColors, acertaSemanticColors } from './acerta';
import { cipalColors, cipalSemanticColors } from './cipal';
import {
  borderRadius,
  colors,
  descriptiveTokens,
  fonts,
  semanticColors,
  spacing,
  textStyles
} from './common';
import { liantisColors, liantisSemanticColors } from './liantis';
import { payflipDarkColors } from './payflip-dark';

const baseTheme = extendTheme({
  colors: {
    ...colors,
    ...descriptiveTokens,
    ...semanticColors
  },
  fonts,
  textStyles,
  space: {
    ...spacing
  },
  sizes: {
    ...ChakraTheme.space,
    ...spacing
  },
  radii: {
    ...ChakraTheme.borders,
    ...borderRadius
  },
  components: {
    Button: ButtonTheme,
    Heading: HeadingTheme,
    Checkbox: CheckboxTheme,
    Switch: SwitchTheme,
    Radio: radioTheme,
    Tooltip: tooltipTheme,
    StatusCard: StatusCardTheme
  }
});

const liantisTheme = extendTheme(
  {
    colors: { ...liantisColors, ...liantisSemanticColors }
  },
  baseTheme
);

const darkTheme = extendTheme(
  {
    colors: payflipDarkColors
  },
  baseTheme
);

const cipalTheme = extendTheme(
  {
    colors: { ...cipalColors, ...cipalSemanticColors }
  },
  baseTheme
);
const acertaTheme = extendTheme(
  {
    colors: { ...acertaColors, ...acertaSemanticColors }
  },
  baseTheme
);

export const themeNames = [
  'payflip',
  'liantis',
  'payflip-dark',
  'cipal',
  'acerta'
] as const;
export type ThemeName = (typeof themeNames)[number];

export function getTheme(themeName: ThemeName): typeof baseTheme {
  switch (themeName) {
    case 'liantis': {
      return liantisTheme;
    }
    case 'payflip-dark': {
      return darkTheme;
    }
    case 'payflip': {
      return baseTheme;
    }
    case 'cipal': {
      return cipalTheme;
    }
    case 'acerta': {
      return acertaTheme;
    }
    default: {
      return baseTheme;
    }
  }
}

export const theme = baseTheme;
